import {Toast} from '@shopify/app-bridge/actions';
import {AxiosError} from 'axios';

export default new class Alert {
    success(message: string): void {
        this.show(message);
    }

    error(message: string): void {
        this.show(message, 'error');
    }

    axiosError(axiosError: AxiosError): void {
        const error = axiosError.response?.data?.message;
        this.error(error);
    }

    private show(message: string, type?: string): void {
        // @ts-ignore
        if (window.app) {
            // @ts-ignore
            const toastNotice = Toast.create(window.app, {
                message: message,
                duration: 3000,
                isError: type === 'error',
            });

            toastNotice.dispatch(Toast.Action.SHOW);
        } else {
            // app not loaded, alert instead
            alert(message);
        }
    }
};
